module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-content"
  }, [_c('app-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbList
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._t("sidebar")], 2), _vm._v(" "), _c('main', {
    staticClass: "col-16"
  }, [_vm._t("content")], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac28a86a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/MainLayout.vue
// module id = 56
// module chunks = 2 3 4